module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-22-e10bb19c682e8a965717b811c3033e6d.png";